module.exports = __webpack_public_path__ + "img/direct-left.00e5cf3e.svg";